<!-- @formatter:off -->
<markdown clipboard mermaid ngPreserveWhitespaces>
```typescript
  const selectables = Object.keys(TestEnum)
    .filter((key: any) => parseInt(key) >= 0)
    .map((key: string) => (&#123; key: key, value: TestEnum[key as keyof typeof TestEnum] &#123;));
  const nameAttr = new BaseEntityAttrDescriptor('name', FormControlType.TEXT_BOX, 'Name', undefined, true);
  const descriptionAttr = new BaseEntityAttrDescriptor('description', FormControlType.TEXTAREA, 'Description');
  const booleanAttr = new BaseEntityAttrDescriptor('boolean', FormControlType.CHECKBOX, 'Boolean');
  const numberAttr = new BaseEntityAttrDescriptor('number', FormControlType.TEXT_BOX, 'Number', undefined, false, &#123; inputType: 'number' &#123;);
  const dateAttr = new BaseEntityAttrDescriptor('date', FormControlType.DATE, 'Date', undefined, false, &#123; inputType: 'date' &#123;);
  const enumAttr = new BaseEntityAttrDescriptor('enumValue', FormControlType.DROPDOWN, 'Enum', selectables);
  const column_1 = new FlexboxContainer([nameAttr, descriptionAttr, booleanAttr], FlexDirection.COLUMN);
  const column_2 = new FlexboxContainer([numberAttr, dateAttr, enumAttr], FlexDirection.COLUMN);

  const flexBoxContainer = new FlexboxContainer([column_1, column_2], FlexDirection.CONTAINER); flexBoxContainer.style = &#123; 'column-gap': '20px' &#123;;
  export const testEntityDescriptors: AbstractAttrDescriptor[] = [flexBoxContainer];
```
</markdown>
<!-- @formatter:on -->
<base-entity-container [entityDescriptor]="baseEntityDescriptor"></base-entity-container>
